//these are not initial values, the values in this object are the names of the keys that will get put into localstorage
export const localStorageVariables = {
  displayNameKey: "displayName",
  userid: "userid",
  clientId: "clientId",
  lastModifying: "lastModifying",
  readNotifications: "readNotifications",
  lastSelectedNotificationTab: "lastSelectedNotificationTab",
  doNotShowClaimNoticeAgain: "doNotShowClaimNoticeAgain",
  clientLoc: "clientLoc",
  dedicatedOrdersSortByField: "dedicatedOrdersSortByField",
  dedicatedOrdersSortByDesc: "dedicatedOrdersSortByDesc",
  // viewDedicatedOrderDetailsByField: "viewDedicatedOrderDetailsByField", //didn't like the feel of this stored in local storage
  dedicatedShowInactivePositions: "dedicatedShowInactivePositions",
  dedicatedPositionSortByField: "dedicatedPositionSortByField",
  dedicatedPositionSortByDesc: "dedicatedPositionSortByDesc",
  postOrderLabelPrintMethod: "postOrderLabelPrintMethod",
  orderTerminology: "orderTerminology",
  positionTerminology: "positionTerminology",
  surveyLastMonthCompleted: "surveyLastMonthCompleted",
  lastClosedAnnouncementBanner: "lastClosedAnnouncementBanner",
  cacheBustDate: "cacheBustDate",
};

export const pages = {
  mainPage: {
    url: "/dashboard",
  },
  clientDashboard: {
    url: "/dashboard",
  },
  orderHistory: {
    url: "/order-history",
  },
  loginPage: {
    url: "/login",
  },
  helpPage: {
    url: "/help",
  },
  trackBarcode: {
    url: "/TrackBarcode",
  },
  cdkSubscription: {
    url: "/cdk-subscription",
  },
  cdkIntroduction: {
    url: "/cdk-intro",
  },
  cdkSignUp: {
    url: "/cdk-signup",
  },
  cdkOrderImport: {
    url: "/CDK-order-import",
  },
  dedicatedDispatch: {
    url: "/dedicated-dispatch",
  },
  viewConcern: {
    url: "/delivery-concern", //table without id, details with id
  },
  viewClaim: {
    url: "/claim", //table without id, details with id
  },
  viewProfile: {
    url: "/view-profile",
  },
  returnRequest: {
    url: "/return-request",
  },
  settings: {
    url: "/settings",
  },
  //reports
  CODReport: {
    url: "/COD-report",
  },
};
export const divisionCategories = {
  network: "network",
  dedicated: "dedicated",
};
export const statesOptions = (
  <>
    <option value="AL">AL</option>
    <option value="AK">AK</option>
    <option value="AZ">AZ</option>
    <option value="AR">AR</option>
    <option value="CA">CA</option>
    <option value="CO">CO</option>
    <option value="CT">CT</option>
    <option value="DE">DE</option>
    <option value="FL">FL</option>
    <option value="GA">GA</option>
    <option value="HI">HI</option>
    <option value="ID">ID</option>
    <option value="IL">IL</option>
    <option value="IN">IN</option>
    <option value="IA">IA</option>
    <option value="KS">KS</option>
    <option value="KY">KY</option>
    <option value="LA">LA</option>
    <option value="ME">ME</option>
    <option value="MD">MD</option>
    <option value="MA">MA</option>
    <option value="MI">MI</option>
    <option value="MN">MN</option>
    <option value="MS">MS</option>
    <option value="MO">MO</option>
    <option value="MT">MT</option>
    <option value="NE">NE</option>
    <option value="NV">NV</option>
    <option value="NH">NH</option>
    <option value="NJ">NJ</option>
    <option value="NM">NM</option>
    <option value="NY">NY</option>
    <option value="NC">NC</option>
    <option value="ND">ND</option>
    <option value="OH">OH</option>
    <option value="OK">OK</option>
    <option value="OR">OR</option>
    <option value="PA">PA</option>
    <option value="RI">RI</option>
    <option value="SC">SC</option>
    <option value="SD">SD</option>
    <option value="TN">TN</option>
    <option value="TX">TX</option>
    <option value="UT">UT</option>
    <option value="VT">VT</option>
    <option value="VA">VA</option>
    <option value="WA">WA</option>
    <option value="WV">WV</option>
    <option value="WI">WI</option>
    <option value="WY">WY</option>
  </>
);

export const landingPageOptions = {
  dashboard: {
    value: "dashboard",
    label: "Dashboard",
    url: pages.clientDashboard.url,
  },
  orderHistory: {
    value: "orderHistory",
    label: "Order History",
    url: pages.orderHistory.url,
  },
};

export const minBarcodeLength = 8;
export const orderSearchCategoriesOrderHistoryCombobox = {
  invoice: { display: "Invoice", value: "Invoice" },
  barcode: { display: "Barcode", value: "Barcode" },
};
export const orderSearchCategories = {
  invoice: { display: "Invoice", value: "Invoice" },
  barcode: { display: "Barcode", value: "Barcode" },
  dateRange: { display: "By Date", value: "DateRange" },
};
// export const orderSearchCategoriesArray = [
//   { display: "Invoice", value: "Invoice" },
//   { display: "Barcode", value: "Barcode" },
// ];

export const orderTypes = {
  regular: "Regular",
  return: "Return",
  buyout: "Buy Out",
};

//contact emails
export const emails = {
  supportEmail: "DCPSupport@diligentusa.com",
  opsEmail: "OPS@diligentusa.com",
  claimsEmail: "Claims@diligentusa.com",
};
export const contactNumbers = {
  directLineSupportNumber: "713-333-0922",
};

export const errorCodes = {
  notMainAccount: {
    //Client needs their jwt token's IsMainAccount value to be true to access the page or feature.
    errorCode: "CDIL-45",
    errorMessage: `You will need to use your company's main DCP account to access this feature or page.\n If your company does not have an account with access, please contact ${emails.supportEmail} for assistance.`,
    reason: "Need Main Account access level to access.",
  },
  modifyPageDirectly: {
    errorCode: "CDIL-521",
    errorMessage: "Please modify orders through the order options menu.",
    reason: "This page must be reached from the order options menu.",
  },
};

export const orderHistoryVars = {
  defaultFromOffset: -4,
  defaultToOffset: 2,
  searchCategories: {
    invoice: "Invoice",
    barcode: "Barcode",
  },
};

export const codOptions = {
  None: { value: "", display: "None" },
  COD: { value: "COD", display: "COD" },
  CertifiedFunds: { value: "CertifiedFunds", display: "Certified Funds" },
};
export const ActionCenterModes = {
  deliveryconcern: "Create a New Delivery Concern",
  codresearch: "Initiate COD Research",
  claim: "File a New Claim",
  return: "Request a Return",
  manualreturn: "Request a Manual Return",
};

export const orderStatuses = {
  open: "Open", //Order has no scan we consider a valid scan, e.g. no scans at all or only dock loads with no scanned whens
  pickedUp: "Picked Up",
  inTransit: "In Transit",
  outForDelivery: "Out for Delivery", //route load stop
  partialDelivery: "Partial Delivery", //some packages, but not all have been delivered
  deliveredStar: "Delivered*", //Not scanned at delivery stop, but marked as completed/has POD
  deliveredStarStar: "Delivered**", //has wrong invoice number associated to delivery scan (likely scanned onto the wrong order through the app when delivering multiple orders to the same location)
  italicsDelivered: "-Delivered-", //Has a delivery scan but never marked as completed/does not have a POD
  delivered: "Delivered", //Has a delivery scan and marked as completed/has POD
  deliveredWithPossibleException: "Delivered with Possible Exception",
  possibleException: "Possible Exception",
  exception: "Exception",
};
//Maybe replace all the values inside here with the above variables?
export const statusFilterMap = {
  open: ["Open"],
  // pickedUp: ["Picked Up"], grouping with in transit
  inTransit: ["In Transit", "Picked Up"],
  outForDelivery: ["Out for Delivery"],
  partialDelivery: ["Partial Delivery"],
  delivered: [
    "Delivered",
    "-Delivered-",
    "Delivered*",
    "Delivered**",
    "Exception",
    "Delivered with Possible Exception",
  ],
  possibleException: [
    "Possible Exception",
    "Delivered with Possible Exception",
    "Delivered*",
    "Delivered**",
    "Exception",
  ],
};
const scannedOnWrongInvoiceAndLocationExceptionMessage = `This item may have been scanned at the incorrect location.`;
const completedOnWrongInvoiceAndLocationExceptionMessage = `This item may have been completed at the incorrect location.`;

const wrongInvoiceAndLocationExceptionNotYetFixed = `If the scan location below looks wrong, please contact OPS at ${emails.opsEmail} or at ${contactNumbers.directLineSupportNumber} to inquire about the situation.`;
const issueHasBeenFixedMessage = "The issue has been corrected.";
export const deliveryExceptions = {
  deliveryScanOnWrongOrder: {
    message: `${scannedOnWrongInvoiceAndLocationExceptionMessage} ${wrongInvoiceAndLocationExceptionNotYetFixed}`,
  },
  deliveryCompletedOnWrongOrder: {
    message: `${completedOnWrongInvoiceAndLocationExceptionMessage} ${wrongInvoiceAndLocationExceptionNotYetFixed}`,
  },
  deliveryScanPreviouslyOnWrongOrder: {
    message: `${scannedOnWrongInvoiceAndLocationExceptionMessage} ${issueHasBeenFixedMessage}`,
  },
  deliveryCompletedPreviouslyOnWrongOrder: {
    message: `${scannedOnWrongInvoiceAndLocationExceptionMessage} ${issueHasBeenFixedMessage}`,
  },
  hadScansButNotOnDelivery: {
    message: "This item was not scanned at delivery.",
  },
  hasNoScans: {
    message: "This item was never scanned.",
  },
};

export const pdfLinks = {
  termsAndConditions: "/pdfs/NDLI TERMS and CONDITIONS 060514.pdf",
  termsAndConditionsLogin: "/pdfs/Network Terms and Conditions.pdf",
  claimsProcedure: "/pdfs/NDLI Freight Claims Procedures 011215.pdf",
  returnsProcedure: "/pdfs/Returns.pdf",
  codOptInForm: "/pdfs/CoD_Opt_In_Form.pdf",
  nationalOperationsContactList: "/pdfs/National Operations Contact List.pdf",
  usersGuide: "/pdfs/Users Guide - Version 1.pdf",
};
export const docLinks = {
  CDKEULA: "/docs/Parts Delivery Logistics Version 10092023 (002).docx", //Please remember to update the html if the document/pdf changes.
};

//keep in sync with the jwt token (backend files: userhelper.cs, TokenManager.cs, AccountController.cs)
//want access levels for developers / diligent master accounts as well
export const accesses = {
  IsMainAccount: "IsMainAccount",
  Admin: "Admin",
  Developer: "Developer",
  Base: "Base",
  Deltrans: "Deltrans",
  Concerns: "Concerns",
  Claims: "Claims",
  Invoice: "Invoice",
};
export const divisionAccesses = {
  dedicated: "Dedicated",
  network: "Network",
};
//below are feature level accesses, only certain clients have access to these features,
export const featureAccesses = {
  IsCdkClient: "IsCdkClient",
};

export const viewStates = {
  initial: "initial",
  success: "success",
  loading: "loading",
  error: "error",
  nodata: "nodata",
};

export const batchPrintMaxDateRange = 3;
//make order history constants, default date from and date to, etc

export const customerSelectionTypes = {
  existing: "existing",
  account: "account",
  new: "new",
};

export const orderHistoryPreFilters = {
  All: "all",
  CDK: "cdk",
};

export const postOrderLabelPrintMethods = {
  directToPrint: "directToPrint",
  download: "download",
  newTab: "newTab",
  popup: "popupOld",
  modal: "modal",
};
export const orderAndPositionTerminologyOptions = {
  orderTerminology: {
    order: "Order",
    invoice: "Invoice",
  },
  positionTerminology: {
    position: "Position",
    route: "Route",
  },
};

export const postOrderLabelPrintOptions = [
  {
    value: "modal",
    label: "Open label viewer modal",
  },
  {
    value: "directToPrint",
    label: "Initiate print on placing order",
  },
  {
    value: "download",
    label: "Download labels",
  },
  {
    value: "newTab",
    label: "Open label viewer in a new tab",
  },
  {
    value: "popupOld",
    label: "Open label viewer in a popup window (Not Recommended)",
  },
];

//"":Piece, "S": Pallet, "E": Engine, "M": Transmission, "O": Oversized, "P": Parcel
export const pieceTypes = {
  Piece: { value: " ", display: "Piece" },
  Pallet: { value: "S", display: "Pallet" },
  Engine: { value: "E", display: "Engine" },
  Transmission: { value: "M", display: "Transmission" },
  Oversized: { value: "O", display: "Oversized" },
  // Parcel: { value: "P", display: "Parcel" },
};

export const newPieceTypes = {
  Package: { value: "", display: "Package" },
  Pallet: { value: "S", display: "Pallet" },
  Engine: { value: "E", display: "Engine" },
  Transmission: { value: "M", display: "Transmission" },
  Oversized: { value: "O", display: "Oversized", staysSingular: true },
};
export const newPieceTypesValueMap = Object.keys(newPieceTypes).reduce(
  (rolling, current) => {
    rolling[newPieceTypes[current].value] = current;
    return rolling;
  },
  {},
);
export const getPieceTypeDisplay = (pieceTypeValue) => {
  return newPieceTypes[newPieceTypesValueMap[pieceTypeValue]].display;
};
export const displayPieceType = (numLabels, pieceType) => {
  return (
    numLabels +
    " " +
    getPieceTypeDisplay(pieceType) +
    (numLabels > 1 &&
    !newPieceTypes[newPieceTypesValueMap[pieceType]].staysSingular
      ? "s"
      : "")
  );
};

export const calculateValueCovered = (
  isPurchasingInsurance,
  declaredValue,
  maximumValuationAmount,
  minimumValuationAmount,
) => {
  // console.log(declaredValue);
  return Math.max(
    0,
    isPurchasingInsurance
      ? Math.min(
          maximumValuationAmount,
          declaredValue === "" ? 0 : declaredValue,
        ).toFixed(2)
      : Math.min(
          minimumValuationAmount,
          declaredValue === "" ? 0 : declaredValue,
        ).toFixed(2),
  ).toFixed(2);
};

export const getInsuranceFee = (
  isPurchasingInsurance,
  declaredValue,
  maximumValuationAmount,
  minimumValuationAmount,
  valuationRate, //DIVIDE THIS BY 100 BEFORE YOU PASS IN FOR NOW. NEED TO REFACTOR THIS ENTIRELY.
) => {
  if (isPurchasingInsurance && declaredValue > minimumValuationAmount) {
    return Math.max(
      2.5,
      Math.min(maximumValuationAmount, declaredValue) * valuationRate,
    ).toFixed(2);
  } else {
    return 0;
  }
};

//check in every place they could print.
//Currenty:
//prevent downloading/displaying label on post order form - done
//probably need to do the same for buyouts
//probably need to do the same for returns - does not currently download/display label
//remove the print label button in the dropdown options on order history page. - done
//remove the batch print button - done
export const clientsToBeExcludedFromPrintingLabels = [
  18398, //Paychex
  // 22622,
];

//CDK
export const cdkSubscriptionStatuses = {
  pending: "Pending",
  active: "Active",
  inactive: "Cancelled",
  cancellationPending: "Pending Cancellation",
  notSubscribed: "Not Subscribed",
};
//CDK End

export const isEligibleForCDKTrial = (currentStatus) => {
  return currentStatus === null;
};

//form rules
export const CDKOrderEditingRules = {
  invoiceNumber: {
    maxLength: 11, //this is 11 on the front end and backend, 13 in deltrans
    required: true,
  },
  customerName: {
    maxLength: 50, //50 in deltrans
  },
  customerAddress: {
    maxLength: 50, //50 in deltrans
    required: true,
  },
  customerZip: {
    maxLength: 10, //10 in deltrans
    required: true,
  },
};

//put this here if we want to add some styles to reference but css is preferred.
export const styles = {
  colors: {
    dilBlue: "#007ac2",
  },
};

export const CDKRawDataFieldsToHide = ["totalPartsCost"];
export const generateCDKDestinationInfo = (orderData) => {
  const cityStateZipArray = orderData.customerCSZ.trim().split(" ");
  const zip = cityStateZipArray[cityStateZipArray.length - 1];
  const state = cityStateZipArray[cityStateZipArray.length - 2];
  let city = "";
  for (let i = 0; i < cityStateZipArray.length - 2; i++) {
    city += cityStateZipArray[i];
  }
  return {
    customerName: orderData.customerName,
    customerName2: orderData.customerName2,
    address: orderData.customerAddress,
    city: city,
    state: state,
    zip: zip,
    // city: orderData.customerCity,
    // state: orderData.customerState,
    // zip: orderData.customerZip,
  };
};
